import { DateUtil } from '../../shared/utils/Date/date-util';
var DtvCatalogUtils = /** @class */ (function () {
    function DtvCatalogUtils() {
    }
    DtvCatalogUtils.getPriceForProduct = function (packs, omapiId) {
        var pack = packs.filter(function (p) { return p.omapiId === omapiId; }).pop();
        return (pack !== undefined) ? pack.priceDetail : undefined;
    };
    DtvCatalogUtils.getTvShopEntertainmentPackForOmapiId = function (packs, omapiId) {
        return packs.filter(this.findPacksWithOmapiId(omapiId)).pop();
    };
    DtvCatalogUtils.getStreamingServicesOptionForOmapiId = function (streamingServicesPacks, omapiId) {
        return streamingServicesPacks.filter(this.findPacksWithOmapiId(omapiId)).pop();
    };
    DtvCatalogUtils.findPacksWithOmapiId = function (omapiId) {
        return function (pack) { return pack.omapiId === omapiId; };
    };
    DtvCatalogUtils.onTrialActivated = function (packs, trial) {
        if (!trial) {
            return;
        }
        var trialPack = packs.filter(this.findPacksWithOmapiId(trial.omapiId)).pop();
        var parentPack = packs.filter(this.findPacksWithOmapiId(trial.parentOmapiId)).pop();
        if (trialPack) {
            trialPack.subscribed = true;
            trialPack.endDate = DateUtil.getTrialEndDate(trial);
        }
        if (parentPack) {
            parentPack.hasTrial = true;
        }
    };
    return DtvCatalogUtils;
}());
export { DtvCatalogUtils };
